// Components/layouts/ProtectedLayout.jsx
import React, { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

const ChatbotWidget = lazy(() => import('./ChatBotWidget'));

export default function ProtectedLayout() {
  return (
    <>
      {/* Protected pages content */}
      <Outlet />

      <Suspense fallback={null}>
        <ChatbotWidget />
      </Suspense>
    </>
  );
}
